import { gql } from '../../../artifacts/gql';

export const getUserOffersStatus = gql(`
  query webUserOffersStatusCCQuery {
    collectCurrentUserV2 {
      tenantId
      accountFunds {
        usableFunds {
          ...Money
        }
      }
      collectBoInvoiceSummary {
        overdueInvoiceCount
        pendingInvoiceCount
      }
      collectWaitingOffersCount
      hasNewOffersFromSellers
      hasNewOffersFromBidders
    }
    currentBalance {
      amount
      currency
    }
    fancashBalance {
      balance {
        amount
        currency
      }
    }
  }
`);
